<template>
  <form v-if="production" class="prod-stack" @submit.prevent="onSave">
    <div class="move-card prod-panel space-y-4">
      <ProductionSectionHead
        title="Platforms"
        subtitle="Where this production is meant to publish, and the live link once it’s out."
      />
      <div class="prod-platforms">
        <div v-for="(label, key) in platformLabels" :key="key" class="space-y-2">
          <label class="prod-chip" :class="{ 'is-on': selected.includes(key) }">
            <input v-model="selected" type="checkbox" :value="key" />
            <span class="text-sm font-semibold">{{ label }}</span>
          </label>
          <input
            v-if="selected.includes(key)"
            v-model="links[key]"
            type="text"
            inputmode="url"
            autocomplete="url"
            class="move-input"
            :placeholder="`${label} URL`"
          />
        </div>
      </div>
      <p v-if="message" class="prod-success">{{ message }}</p>
      <button type="submit" class="move-btn-primary">Save platforms</button>
    </div>
  </form>
</template>

<script setup>
import { inject, reactive, ref, watch } from 'vue'
import ProductionSectionHead from '../../components/production/ProductionSectionHead.vue'
import { platformLabels } from '../../config/productionNavigation'

const workspace = inject('productionWorkspace')
const production = workspace.production
const selected = ref([])
const links = reactive({})
const message = ref('')

watch(production, (value) => {
  selected.value = [...(value?.platforms || [])]
  Object.keys(links).forEach((key) => { delete links[key] })
  Object.entries(value?.release_links || {}).forEach(([key, url]) => {
    links[key] = url
  })
}, { immediate: true })

async function onSave () {
  const releaseLinks = {}
  selected.value.forEach((key) => {
    if (links[key]) releaseLinks[key] = links[key]
  })
  await workspace.save({
    platforms: selected.value,
    release_links: releaseLinks
  })
  message.value = 'Platforms and links saved.'
}
</script>
